declare namespace $ {

	export class $mol_icon_view_column extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=column.view.tree.d.ts.map